module.exports = __webpack_public_path__ + "img/game-controller.1f16e05f.png";